import { TemplateResult } from 'lit-html';
import JrModal from '@libs/modal/index';
import { getWhat, getWhere } from '@services/search-service';
import { updateProfile } from '@services/xhr-service';
import { JtagService } from '@services/jtag-service';
import UpdatePasswordTemplate from './templates';


export default class UpdatePasswordModal extends JrModal {
  private loading = false;
  private formSubmitted = false;
  private formData: IUpdatePasswordFormData;
  private formError: 'required' | 'pattern' | '' = '';
  private genericError: boolean = false;
  private inputType: 'password' | 'text' = 'password';


  constructor(
    readonly customModalClass: string,
    readonly wrapperClass: string,
    readonly jrConfigGlobal: JrConfigGlobal
  ) {
    super(customModalClass, wrapperClass, jrConfigGlobal);
    this.formData = this.getFormData(jrConfigGlobal);
  }


  getContent = async (): Promise<TemplateResult> => UpdatePasswordTemplate(this.getModel());

  openedCallback = (): void => { }

  private getFormData = (jrConfigGlobal: JrConfigGlobal): IUpdatePasswordFormData => {
    return {
      what: getWhat(),
      where: getWhere(),
      jobSeekerEmail: jrConfigGlobal.user.subscribedEmail || jrConfigGlobal.user.mail,
      password: ''
    }
  }

  handleSubmit = async (event: Event): Promise<void> => {
    event.preventDefault();
    const updatePasswordForm = (<HTMLFormElement>event.target);
    const isValidForm = updatePasswordForm.checkValidity();

    this.formSubmitted = true;
    this.loading = true;
    this.genericError = false;
    this.formError = '';

    this.render();

    if (isValidForm) {
      try {
        const response: Response = await updateProfile({ password: this.formData.password, confirmPassword: this.formData.password });
        if (response.status >= 200 && response.status < 300) {
          JtagService.trackCustomEvent('click_confirmation_popup', {
            event_label: 'add_password',
          });
          this.close();
        } else {
          this.loading = false;
          this.genericError = true;
        }
      } catch (e) {
        this.loading = false;
        this.genericError = true;
      }
    } else {
      this.loading = false;
      this.formError = !this.formData.password ? 'required' : 'pattern';
    }
    this.render();
  }

  togglePasswordInput = (): void => {
    this.inputType = this.inputType === 'password' ? 'text' : 'password';
    this.render();
  }

  handlePasswordInput = (event: Event): void => {
    const eventValue = (<HTMLInputElement>event.target).value.trim();

    if (eventValue) {
      this.formData.password = eventValue;
    } else {
      this.formData.password = '';
    }
    this.render();
  }

  private getModel = (): IUpdatePasswordModel => ({
    handleSubmit: this.handleSubmit,
    close: this.close,
    togglePasswordInput: this.togglePasswordInput,
    handlePasswordInput: this.handlePasswordInput,
    messages: this.jrConfigGlobal.messages,
    loading: this.loading,
    inputType: this.inputType,
    formData: this.formData,
    formSubmitted: this.formSubmitted,
    formError: this.formError,
    genericError: this.genericError
  });
}